var React = require('react');

function Bd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#006a4e","d":"M0 0h640v480H0z","key":0}),React.createElement("circle",{"cx":"280","cy":"240","r":"160","fill":"#f42a41","key":1})]);
}

Bd.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bd;

Bd.default = Bd;
